export const HEADERBAR_CONSTANT = {
  MODAL_TITLE_LOGOUT: 'Confirm Logout?',
  MODAL_CONTENT_LOGOUT: 'Are you sure want to log out?',
  MODAL_OK_BUTTON_LOGOUT: 'Yes, Confirm',
  MODAL_CANCEL_BUTTON_LOGOUT: 'Cancel',
}